function dlog() {
  const debug = process.env.GATSBY_DEBUG === "1"
  if (debug) {
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, args);
  }
}

module.exports = dlog;
